import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Results from './components/Results';
import Industries from './components/Industries';
import Process from './components/Process';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import BookCallModal from './components/BookCallModal';

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <main className="bg-black min-h-screen">
      <Navbar onBookCall={() => setModalOpen(true)} />
      <Hero onBookCall={() => setModalOpen(true)} />
      <Results />
      <Industries />
      <Process />
      <CaseStudies />
      <Testimonials />
      <CtaSection onBookCall={() => setModalOpen(true)} />
      <Footer />
      <BookCallModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </main>
  );
}
